// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"17b49a77","453":"20359781"}[chunkId] + ".chunk.js";
};